import React, { useEffect } from 'react';
import { BrowserRouter, Route, Redirect } from 'react-router-dom';
import ReactGA from 'react-ga4';
import TagManager from 'react-gtm-module'
import { Helmet } from "react-helmet";
import { Pages } from './common/LinkRoutes';
import templateServices from './services/TemplateServices';
import AccountAction from './actions/AccountAction';
import SettingActions from './actions/SettingActions';
import CommonUtil from './common/CommonUtil';
import { VIEW, PLAYER_TYPE, PrefsMap } from './common/Foundation';
import { EVENT } from './events/listEvents';
import i18next from 'i18next'
import './../styles/css/WaitLoading.css';
import CommonActions from './actions/CommonActions';
import { useSelector, useDispatch } from 'react-redux';
import { LayoutTemplateSlice } from './slices/LayoutTemplateSlice';
import DynamicPage from './pages/DynamicPage';
import { AccountsSlice } from './slices/AccountsSlice';
import { updateOptionsFromUdata, updateFavouritesAndAllowFetchFavourites } from './slices/SportsSlice';
import AlertComponent from './components/BaseComponent/AlertComponent';
import NotificationComponent from "./components/CompactView/NotificationComponent";
import MessPopUpComponent from "./components/MessPopUpComponent";
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import cookie from 'react-cookies';
import MemberServices from './services/MemberService';
import OddsPageActions from "./components/CompactView/OddsPageComponent/OddsPageActions";
import { SportsSlice } from './slices/SportsSlice';
import { BetslipSlice } from './slices/BetslipSlice';
import LoginMessageComponent from './components/CompactView/LoginMessageComponent';
import CasinoCallback from './pages/CasinoCallback';

const defaultFavoriteData = {
	leagueIds: [],
	eventIds: []
}

const Routes = (props) => {
	const { actions } = LayoutTemplateSlice;
	const currentViewContainer = useSelector(state => state.LayoutTemplateSlice.currentViewContainer);
	const isWait = useSelector(state => state.LayoutTemplateSlice.isWait);
	const isAuth = useSelector(state => state.AccountsSlice.user.auth);
	const dispatch = useDispatch();
	const modeDev = false;
	//hardcode: skin ps3838 for dev
	let templateName = 'pa';
	const allParams = CommonActions.getAllUrlParams(window.location.href);
	if (allParams.templatename != null && allParams.templatename.length > 0) {
		templateName = allParams.templatename;
	}

	useEffect(() => {
		checkLogout(); // Check case update URL + Enter
		CommonUtil.saveUserData("newBetslipPopupEnabled", false); // To avoid displaying betslip popup by using old __udata
		updateViewAction();
    const initGlobalData = async () => {
      const promise = modeDev
        ? templateServices.loadTemplateDataFromLocal(templateName)
        : templateServices.loadTemplateData();
      const res = await promise;
      if (res) {
        handleTemplateResponse(res);
		getDataNoCache();
      }
    }
    initGlobalData();
		window.onbeforeunload = function () {
			window.scrollTo(0, 0);
		}
		window.listenEvent(EVENT.CSS_LOADED, updateWaitLoading);
		window.listenEvent(EVENT.GET_DATA_NOCACHE, getDataNoCache);
		window.listenEvent(EVENT.UPDATE_VIEW, updateViewAction);
		return function cleanup() {
			// componentWillUnmount
			window.stopListenEvent(EVENT.CSS_LOADED, updateWaitLoading);
			window.stopListenEvent(EVENT.GET_DATA_NOCACHE, getDataNoCache);
			window.stopListenEvent(EVENT.UPDATE_VIEW, updateViewAction);
		}
	}, []);

	useEffect(() => {
		if (isAuth) {
			OddsPageActions.getSportsbookFavoriteByUserId().then(response => {
				const favData = response || defaultFavoriteData;
				dispatch(updateFavouritesAndAllowFetchFavourites(favData));
			})
		}
	}, [isAuth])


	function initGoogleLib() {
		if (!window.env || !window.env.isEnableGaGtm) {
			return;
		}
		if (window.env.gaWebId) {
			ReactGA.initialize(window.env.gaWebId);
			ReactGA.send({ hitType: "pageview", page: window.location.pathname});
		}
		if (window.env.gtmWebId) {
			const tagManagerArgs = {
				gtmId: window.env.gtmWebId
			}

			TagManager.initialize(tagManagerArgs);
		}
  }
  
  function injectTrackingScripts() {
    if (window.env.hotJarId) {
      const hotJar = document.createElement("script");
      hotJar.innerHTML = `
      (function(h,o,t,j,a,r){
        h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
        h._hjSettings={hjid:${window.env.hotJarId},hjsv:6};
        a=o.getElementsByTagName('head')[0];
        r=o.createElement('script');r.async=1;
        r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
        a.appendChild(r);
      })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');`;
      document.head.appendChild(hotJar);
    }

		if(window.env.botManagementKey) {
			const botManagement = document.createElement("script");
			botManagement.innerHTML = `
				!(function(a,b,c,d,e,f,g){
					a.sikey=e;a.fpendpoint=f;a.siendpoint=g;
					var m=b.createElement(c),n=b.getElementsByTagName(c)[0];
					m.async=1,m.src=d,n.parentNode.insertBefore(m, n);
				})(window,document,"script","https://app.intellifend.com/agentjs/latest/tags-fast.js",
				["${window.env.botManagementKey}","",[]],"https://tls-fp.intellifend.com/","https://app.intellifend.com");`;
			document.head.appendChild(botManagement);
		}
  }
  
  /**
   * If user enters the currency param on URL then we will use this to display on betslip
   * Example: .../compact/sports?currency=VND
   */
  function saveNonLoginCurrency() {
    const { search } = window.location;
    const params = new URLSearchParams(search);
    const currency = params.get("currency");
    if (window.env.isB2B && !currency) return;
    dispatch(BetslipSlice.actions.setNonLoginCurrency(currency));
  }

	function handleTemplateResponse(res) {
		if (!res) {
			return;
		}
		window.env = res.attributes;
		CommonActions.actionWithBrowser(res);
		dispatch(actions.updateTemplateData(res));
    initGoogleLib();
    injectTrackingScripts();
    initFingerPrintId();
    saveNonLoginCurrency();
	}



	/**
	 * Get data nocache
	 */
	function getDataNoCache() {
		AccountAction.getDataNoCache().then(res => {
			if (!res || !res.data || res.error) {
				return;
			}
			const __udata = AccountAction.splitDataNoCache(res.data);
			__udata.userIp = CommonUtil.getRealIP(__udata, res);
      const skin = modeDev ? templateName : __udata.skin;
      // only update default view to current view for pa skin only
      if(
        CommonUtil.isPA() &&
        __udata.auth &&
        window.location.pathname.includes('/sports') && 
        VIEW.COMPACT !== __udata.view
      ) {
				SettingActions.updateDefaultView(VIEW.COMPACT);
				__udata.view = VIEW.COMPACT
			}
			const userData = AccountAction.buildUserData(__udata, skin);
			AccountAction.updateCookieAndStorageFromUdata(__udata, skin);
			AccountAction.updateThemeMode(userData);
					// Make sure Sport Store options is synchronous with Data No Cache
			dispatch(updateOptionsFromUdata(__udata));
					if (__udata.auth) {
						window.fireEvent(EVENT.DATA_NOCACHE_AUTH)
						//load data of user login
						AccountAction.fireEventReloadAccountBalance();
			}
			dispatch(AccountsSlice.actions.updateUser(userData));
			const sportsSorting = CommonUtil.getCookiePrefsByKey(PrefsMap.sportsSorting) || "";
			dispatch(SportsSlice.actions.updateOptions({ sportsSorting }));
			CommonUtil.setCookieDomain();
		}).catch(e => {
		});
	}

	
	function updateWaitLoading() {
		dispatch(actions.updateIsWaitLoading(false));
	}

	function checkLogout() {
		const needToChangePW = localStorage.getItem("_needToChangePW");
		let url = window.location.href;
		if (needToChangePW && !url.includes("change-password")) {
			AccountAction.logout();
		}
	}

	function updateViewAction() {
		const viewContainer = templateServices.getViewByURLPath();
		if (viewContainer !== currentViewContainer) {
			dispatch(actions.updateCurrentViewContainer(viewContainer));
			document.body.classList.add(viewContainer);
			document.documentElement.classList.add(viewContainer);
		}
  }
  
  async function initFingerPrintId() {
    const fp = await FingerprintJS.load();
    const result = await fp.get();
    const currentId = cookie.load('_vid');
    const visitorId = result.visitorId;
    if (!currentId || currentId !== visitorId) {
      CommonUtil.saveCookie('_vid', visitorId, {expires: 60, path: "/", domain: AccountAction.getSubDomain()});
      MemberServices.updateFingerPrintId({"fpId": visitorId});
    }
  }

	function renderRoute() {
		//nin.os: use this regEx to make sure the url contains lang patern like: en, fr or zh-cn,
		const regEx = '([a-z]{2}|[a-z]{2}-[a-z]{2})';
		return (
			<React.Fragment>
				<Route exact path="/" render={(props) => renderPage(props, 'homePageContainer')} />
				<Route exact path={"/:lang" + regEx + "/promotion"} render={(props) => renderPage(props, 'promotionContainer')} />
				<Route exact path={"/:lang" + regEx + "/survey/:surveyId/:promotionId"} render={(props) => renderPage(props, 'promotionSurveyContainer')} />
				<Route exact path={"/:lang" + regEx + "/account"} render={(props) => renderPage(props, 'accountPageContainer')} />
				<Route exact path={"/:lang" + regEx + "/account/:accountPage"} render={(props) => renderPage(props, 'accountPageContainer')} />
				<Route exact path={"/:lang" + regEx + "/account/:accountPage/:paymentChanelCode"} render={(props) => renderPage(props, 'accountPageContainer')} />
				<Route exact path={"/:lang" + regEx + "/account/:accountPage/:paymentChanelCode/:transactionId"} render={(props) => renderPage(props, 'accountPageContainer')} />
				<Route exact path={"/:lang" + regEx + "/:view(compact)/account"} render={(props) => renderPage(props, 'accountPageContainer')} />
				<Route exact path={"/:lang" + regEx + "/:view(compact)/account/:accountPage"} render={(props) => renderPage(props, 'accountPageContainer')} />
				<Route exact path={"/:lang" + regEx + "/:view(compact)/account/:accountPage/:paymentChanelCode"} render={(props) => renderPage(props, 'accountPageContainer')} />
				<Route exact path={"/:lang" + regEx + "/:view(compact)/account/:accountPage/:paymentChanelCode/:transactionId"} render={(props) => renderPage(props, 'accountPageContainer')} />
				<Route exact path={"/:lang" + regEx} render={(props) => renderPage(props, 'homePageContainer')} />
        <Route exact path={"/:lang" + regEx + "/activeLink"} render={(props) => renderPage(props, 'activeLinkContainer')} />
				<Route exact path={"/sports"} render={(props) => renderPage(props, 'sportPageContainer')} />
				<Route exact path={"/:lang" + regEx + "/sports"} render={(props) => renderPage(props, 'sportPageContainer')} />
				<Route exact path={"/:view(compact)/sports"} render={(props) => renderPage(props, 'sportPageContainer')} />
				<Route exact path={"/:lang" + regEx + "/sports/:sportName"} render={(props) => renderPage(props, 'sportPageContainer')} />
				<Route exact path={"/:lang" + regEx + "/vs"} render={(props) => renderPage(props, 'vsPageContainer')} />
				<Route exact path={"/:lang" + regEx + "/:view(compact)/vs"} render={(props) => renderPage(props, 'vsPageContainer')} />
				<Route exact path={"/:lang" + regEx + "/change-password"} render={(props) => renderPage(props, 'changePasswordContainer')} />
        <Route exact path={"/:lang" + regEx + "/:view/search/"} render={(props) => renderPage(props, 'sportPageContainer')} />
				<Route exact path={"/:lang" + regEx + "/search/"} render={(props) => renderPage(props, 'sportPageContainer')} />
				<Route exact path={"/:lang" + regEx + "/search/:searchText"} render={(props) => renderPage(props, 'sportPageContainer')} />
		<Route exact path={"/:lang" + regEx + "/:view/search/:searchText"} render={(props) => renderPage(props, 'sportPageContainer')} />
				{/*classic view*/}
				<Route exact path={"/:lang" + regEx + "/:view/sports"} render={(props) => renderPage(props, 'sportPageContainer')} />
				<Route exact path={"/:lang" + regEx + "/:view/sports/:sportName"} render={(props) => renderPage(props, 'sportPageContainer')} />
				<Route exact path={"/:lang" + regEx + "/:view/sports/:sportName/:leagueName/:leagueId"} render={(props) => renderPage(props, 'sportPageContainer')} />
        <Route exact path={"/:lang" + regEx + "/:view/sports/:sportName/:gameName/:leagueName/:leagueId"} render={(props) => renderPage(props, 'sportPageContainer')} />
		<Route exact path={"/:lang" + regEx + "/:view/sports/:sportName/stats/:leagueName/:eventName/:eventId"} render={(props) => renderPage(props, 'sportPageContainer')} />
		<Route exact path={"/:lang" + regEx + "/sports/:sportName/stats/:leagueName/:eventName/:eventId"} render={(props) => renderPage(props, 'sportPageContainer')} />
				{/* <Route exact path={"/:lang" + regEx + "/:view/sports/:sportName(vs)"} render={(props) => renderPage(props, 'vsPageContainer')} />
				<Route exact path={"/:lang" + regEx + "/:view/sports/:sportName(soccer|basketball|tennis|baseball|e-sports)"} render={(props) => renderPage(props, 'sportPageContainer')} /> */}
				<Route exact path={"/:lang" + regEx + "/:view/lineoffering"} render={(props) => renderPage(props, 'linesPageContainer')} />
				<Route exact path={"/:lang" + regEx + "/:view/parlay-betting-menu"} render={(props) => renderPage(props, 'parlayBettingMenuPageContainer')} />
				{/*general view*/}
				<Route exact path={"/:lang" + regEx + "/syserror"} component={Pages.error} />
				<Route exact path={"/:lang" + regEx + "/register"} component={Pages.register} />
				<Route exact path={"/:lang" + regEx + "/demo"} component={Pages.demo} />
				<Route exact path={"/:lang" + regEx + "/test-comp"} component={Pages.testComp} />
				<Route exact path={"/:lang" + regEx + "/casino"} render={(props) => renderPage(props, 'casinoPageContainer')} />
				<Route exact path={"/:lang" + regEx + "/casino/:product/:gameId"} render={(props) => renderPage(props, 'casinoPageContainer')} />
				<Route exact path={"/:lang" + regEx + "/live-casino"} render={(props) => renderPage(props, 'liveCasinoPageContainer')} />
				<Route exact path={"/:lang" + regEx + "/live-casino/:product/:gameId"} render={(props) => renderPage(props, 'liveCasinoPageContainer')} />
				<Route exact path={"/:lang" + regEx + "/live-casino/loading"} component={CasinoCallback} />
				<Route exact path={"/:lang" + regEx + window.env.leaderBoardPathName} 
					render={(props) => window.env.enableLeaderboard
						? renderPage(props, "leaderboardContainer")
						: <Redirect to={"/"}/> }/>
        <Route exact path={"/:lang" + regEx + "/leaderboard/:sportName/:leagueId"} component={Pages.leaderboardRedirection} />
				<Route exact path={"/:lang" + regEx + "/forgot-email-username"} component={Pages.forgots} />
				<Route exact path={"/:lang" + regEx + "/forgotpassword"} component={Pages.forgots} />
				<Route exact path={"/:lang" + regEx + "/request_activation_link"} component={Pages.activationLink} />
				<Route exact path={"/:lang" + regEx + "/unsubscribe-token"} render={(props) => renderPage(props, 'unsubscribePageContainer')} />
				<Route exact path={"/:lang" + regEx + "/prestige-club"} render={(props) => renderPage(props,'prestigeClubPageContainer')}/>
				<Route exact path={"/:lang" + regEx + "/bet-builder"} render={(props) => renderPage(props, 'betBuilderPageContainer')} />
				{window.env.isNewSignupFormEnabled &&
					<Route exact path={"/:lang" + regEx + "/:view/register"} component={Pages.signUp} />
				}
				<Route exact path={"/:lang" + regEx + "/:view/update-info"} render={(props) => renderPage(props, 'updateInfoContainer')} />
				<AlertComponent />
				<NotificationComponent />
				<MessPopUpComponent />
				{CommonUtil.isEnableFeatureVIP() && <LoginMessageComponent />}
			</React.Fragment>
		)
  }

	function renderPage(props, pageContainer) {
		dispatch(LayoutTemplateSlice.actions.updateCurrentPageContainer(pageContainer));
		return <DynamicPage {...props} pageContainer={pageContainer}></DynamicPage>
	}

	if (isWait) {
		return CommonActions.renderWaitLoading(CommonUtil.getCurrentSkin());
	}

	const pageTitle = CommonUtil.getPageTitle();
	return (
		<BrowserRouter basename={''}>
			<div id="wrapper">
				<Helmet >
					<meta charSet="utf-8" />
					<meta property="og:type" content={window.env.metaType} />
					<link rel="shortcut icon" href={process.env.PUBLIC_URL + '/esthardsk/images/' + window.env.skinName + "/favicon.ico"}></link>
					<title>{pageTitle}</title>

				</Helmet>
				{renderRoute()}
			</div>

		</BrowserRouter >
	)
}

export default (React.memo(Routes));



// WEBPACK FOOTER //
// ./src/app/Routes.js